<template>
  <article :class="[
    isDetail ? 'is-detail' : '',
    'align-' + align]">
    <!-- <h2 v-html="title"></h2> -->
    <blockquote v-if="isDetail" cite="http://www.worldwildlife.org/who/index.html" v-html="title"></blockquote>
    <h5 v-if="isDetail">{{intro}}</h5>
    <h6 v-if="isDetail">{{authorDesc}}</h6>
    <aside v-if="isDetail">
      <p v-html="tc1"></p>
      <p v-html="tc2"></p>
      <p v-html="tc3"></p>
    </aside>
    <h2 v-if="!isDetail" v-html="title">{{title}}</h2>
    <h5 v-if="!isDetail" v-html="intro"></h5>

    <figure v-if="!isDetail" class="mini">
      <img :src="placeBanner" />
    </figure>
    <p v-if="!isDetail" v-html="text"></p>
  </article>
</template>


<script>
import aboutBannerMini from "../assets/banners/about-banner-mini.png";

export default {
  name: "text-component",
  props: [
    "title",
    "text",
    "intro",
    "align",
    "type",
    "tc1",
    "tc2",
    "tc3",
    "authorDesc"
  ],
  computed: {
    isDetail: function() {
      return this.type === "detail";
    },
    placeBanner: function() {
      return aboutBannerMini;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_mixins.scss";

article {
  @include grid-padding;
  @include vertical-padding;
  background: white;
  position: relative;

  @include respond-to(tablet) {
    @include grid(12);
    padding-right: 0;
    padding-left: 0;
  }

  @include respond-to(desktop) {
    grid-column-gap: $default_vmin;
  }

  > h2,
  blockquote {
    @include title-border;
    line-height: 1;
    grid-column: 2 / span 5;
    grid-row: 1 / span 2;

    @include respond-to(desktop) {
      grid-column: 2 / span 6;
    }

    @include respond-to(tv) {
      grid-column: 2 / span 5;
    }
  }

  h2 {
    color: $gray_dark_2;

    :not(.is-detail) & {
      margin-top: $large_vmin;

      @include respond-to(tablet) {
        margin-top: $default_vmin;
        padding-bottom: $default_vmin;
        font-size: 6vmin;
      }

      @include respond-to(desktop) {
        font-size: 11vmin;
      }
    }
  }

  h5 {
    grid-row-start: 3;
    grid-column: 2 / span 5;

    @include respond-to(desktop) {
      grid-column: 2 / span 6;
    }

    @include respond-to(tv) {
      grid-column: 2 / span 5;
    }
  }
  h6 {
    grid-column: 2 / span 5;

    @include respond-to(desktop) {
      grid-column: 2 / span 6;
    }

    @include respond-to(tv) {
      grid-column: 2 / span 5;
    }
  }

  p {
    grid-column: 7 / span 5;

    @include respond-to(tablet) {
      font-size: 1rem;
      grid-row: 2 / span 4;
    }

    @include respond-to(desktop) {
      font-size: 1.125rem;
      margin-top: $default_vmin;
      grid-row: 1 / span 3;
      grid-column: 8 / span 4;
    }

    @include respond-to(tv) {
      grid-column: 7 / span 5;
    }
  }

  figure.mini {
    grid-row-start: 1;
    grid-column: 7 / span 5;

    @include respond-to(desktop) {
      display: none;
    }
  }

  blockquote {
    font-weight: 500;
    margin: 0;
    font-size: $mobile_h1_size;
    line-height: 1;
  }

  &:not(.is-detail) {
    p {
      @include respond-to(tv) {
        column-count: 2;
      }
    }
  }

  &.is-detail {
    @include grid-container;

    blockquote {
      grid-column: 1 / span 4;
      font-size: 6vmax;
      line-height: 1.1;

      @include respond-to(tablet) {
        font-size: 5vmax;
        line-height: 1;
      }

      @include respond-to(desktop) {
        font-size: 8vmin;
        grid-column: 2 / span 6;
      }

      @media (min-width: 1300px) {
        grid-column: 1 / span 7;
      }

      @include respond-to(tv) {
        grid-column: 1 / span 6;
        font-size: 6vmin;
        line-height: 1.1;
      }
    }

    h5 {
      @include respond-to(tablet) {
        grid-column: 1 / span 6;
      }

      @include respond-to(desktop) {
        grid-column: 2 / span 6;
      }

      @media (min-width: 1300px) {
        grid-column: 1 / span 6;
      }
    }

    h6 {
      @include respond-to(tablet) {
        grid-column: 1 / span 6;
      }

      @include respond-to(desktop) {
        grid-column: 2 / span 6;
      }

      @media (min-width: 1300px) {
        grid-column: 1 / span 6;
      }
    }

    aside {
      grid-column: 5 / span 8;
      grid-row: 1 / span 3;

      @include respond-to(desktop) {
        grid-column: 8 / span 4;
      }
      @include respond-to(tv) {
        grid-column: 7 / span 6;
      }
    }

    @include respond-to(tv) {
    }
  }
}
</style>
